/**
 * Copies a chosen photo's bytes into memory the moment it is picked.
 *
 * On Android a file input hands back a live reference to the gallery item, not its bytes,
 * and Chrome refuses a later read when the Photo Picker reports a different modified time
 * than it did at pick (Chromium issues 40123366 and 41452449). So the preview, read right
 * after picking, looked fine, while the read at "Add" minutes later failed — and the <img>
 * decode behind it reported that as "a format the browser could not open". One read,
 * straight away, is the fix: nothing after this touches the phone's copy again.
 */
export async function readChosenPhoto(file: File) {
  try {
    const bytes = await file.arrayBuffer();
    return new File([bytes], file.name, { type: file.type });
  } catch {
    throw new Error("This photo could not be read from the phone. Choose it again.");
  }
}
